<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1500"
      :mask-closable="false"
      title="固件版本统计"
    >
      <template slot="footer">
        <a-button class="ant-btn-primary" @click="closeModal">
          关闭
        </a-button>
      </template>

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        row-key="firmware_version"
      />

      <a-row class="count-tips">
        共 {{ this.tableData.length }} 条记录
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findModuleInventoryFirmwareVersionStatistics } from '@/api/module_inventory'

export default {
  name: 'ModuleInventoryFirmwareVersions',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    moduleModelId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      tableColumns: [
        {
          title: '固件版本',
          dataIndex: 'firmware_version',
          width: 320,
          className: 'import-product-name'
        },
        {
          title: '库存数量',
          dataIndex: 'inventory_count',
          width: 150
        }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      findModuleInventoryFirmwareVersionStatistics(this.moduleModelId).then((res) => {
        this.tableData = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.count-tips {
  padding-top: 20px;
}

::v-deep .import-product-name {
  white-space: normal;
  word-break: break-word;
}
</style>
